// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "ef0f5eaab761789a7e54f8fc00a0fc1d" + ".js";
};